// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__37u1b","title":"Images90_title__2Chze","images":"Images90_images__ngGhS"};